<script lang="ts">
	import ModelSelect from '$lib/ModelSelect.svelte';

	interface Props {
		model: string;
	}

	let { model = $bindable() }: Props = $props();
</script>

<div class="settings">
	<ModelSelect bind:model />
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.settings {
		@include lib.flex-row();
		overflow: hidden;
		gap: 1rem;
	}
</style>
